import { render, staticRenderFns } from "./ModuleView.vue?vue&type=template&id=1634eaba&"
import script from "./ModuleView.vue?vue&type=script&lang=js&"
export * from "./ModuleView.vue?vue&type=script&lang=js&"
import style0 from "./ModuleView.vue?vue&type=style&index=0&id=1634eaba&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports